module.exports = __webpack_public_path__ + "img/add-photo-fourth-icon.4704be6a.svg";